import { defineTranslateKeys } from 'lib/tolgee'

export default defineTranslateKeys({
  title: {
    key: 'MobileNotAllowedRouteModal-title',
    defaultValue: `A Winnin Intelligence ainda não foi projetado para dispositivos móveis.`,
  },
  description: {
    key: 'MobileNotAllowedRouteModal-description',
    defaultValue: 'Por favor, abra a plataforma em uma tela de desktop para ter uma melhor experiência.',
  },
  illustrationDescription: {
    key: 'MobileNotAllowedRouteModal-illustrationDescription',
    defaultValue: 'Computador em uma mesa mostrando a Winnin Intelligence funcionando',
  },
  continueOnThisDevice: {
    key: 'MobileNotAllowedRouteModal-continueOnThisDevice',
    defaultValue: 'Continuar neste dispositivo',
  },
})
